import { Fragment, PropsWithChildren, forwardRef, useRef } from 'react';
import { uniqueId } from 'lodash';

import { useContextSelector } from 'use-context-selector';
import { IonPopover, IonContent } from '@ionic/react';
import classNames from 'classnames';

import { ActionSheetContext } from '../../ActionSheet.context';
import { ActionSheetMenuList } from '../ActionSheetMenuList/ActionSheetMenuList';
import { ActionSheetMenuContext } from '../ActionSheetMenu.context';

import { ActionSheetMenuPopoverPlacement } from './ActionSheetMenuPopover.type';

import styles from './ActionSheetMenuPopover.module.scss';

type ActionSheetMenuPopoverProps = PropsWithChildren<{
  placement?: ActionSheetMenuPopoverPlacement;
}>;

export const ActionSheetMenuPopover = forwardRef<
  HTMLIonPopoverElement,
  ActionSheetMenuPopoverProps
>(({ children, placement = ['bottom', 'end'] }, ref) => {
  const [side, alignment] = placement;

  const { current: className } = useRef(uniqueId('popover'));

  const id = useContextSelector(ActionSheetContext, ({ id }) => id);

  const width = useContextSelector(
    ActionSheetMenuContext,
    ({ width }) => width
  );

  return (
    <Fragment>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .${className} {
                --custom-popover-width: ${!!width ? width + 'px' : 'auto'}
            }
          `,
        }}
      ></style>
      <IonPopover
        ref={ref}
        side={side}
        trigger={id}
        alignment={alignment}
        triggerAction="click"
        className={classNames(styles.root, className)}
      >
        <IonContent>
          <ActionSheetMenuList>{children}</ActionSheetMenuList>
        </IonContent>
      </IonPopover>
    </Fragment>
  );
});
